import { hermioneMediaArray } from './hermioneMedia'
import { hermioneBio } from './hermioneBios'

import { ronReviewerReviewHinge, dumbledoreReviewerReviewBumble, harryReviewerReviewTinder } from './hermioneReviewerReviews'
import { ronReviewerProfile, dumbledoreReviewerProfile, harryReviewerProfile } from './hermioneReviewers'

export const ronProfileReviewHinge = {
  _id: 'ronProfileReviewHingeId',
  userId: 'hermioneUserId',
  userEmail: 'hermione@email.com',
  datingProfileId: 'hermioneDatingProfileHingeId',
  reviewerProfileId: 'ronReviewerProfileId',
  reviewerEmail: 'ron@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: hermioneMediaArray[3]._id,
      mediaItemURL: hermioneMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[3].type,
      caption: hermioneMediaArray[3].captions[1],
      subcaption: hermioneMediaArray[3].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[1]._id,
      mediaItemURL: hermioneMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[1].type,
      caption: hermioneMediaArray[1].captions[1],
      subcaption: hermioneMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: hermioneMediaArray[5]._id,
      mediaItemURL: hermioneMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[5].type,
      caption: hermioneMediaArray[5].captions[0],
      subcaption: hermioneMediaArray[5].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[13]._id,
      mediaItemURL: hermioneMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[13].type,
      caption: hermioneMediaArray[13].captions[2],
      subcaption: hermioneMediaArray[13].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[9]._id,
      mediaItemURL: hermioneMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[9].type,
      caption: hermioneMediaArray[9].captions[2],
      subcaption: hermioneMediaArray[9].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[2]._id,
      mediaItemURL: hermioneMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[2].type,
      caption: hermioneMediaArray[2].captions[2],
      subcaption: hermioneMediaArray[2].subcaptions[1],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Wow against all odds you look like a wizard fatale here. Great start! (As shocking as that is for me to say)`,
      verdict: 'Very',
    },
    {
      feedback: `Looking as contemplative as ever by the fire. It pains me to say that yet again you look good, but maybe smile in one of these?`,
      verdict: 'Yes',
    },
    {
      feedback: `Wow! Who's that babe? Are you sure that's you?`,
      verdict: 'Very',
    },
    {
      feedback: `Action shot! I like it because I know the backstory, but I think someone who doesn't know you might find it a bit intense`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Supermodel alert! Again, it's good, but you look intense in too many photos. Do you ever smile?`,
      verdict: 'Somewhat',
    },
    {
      feedback: `This is funny! Love the caption, and you look good!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: hermioneBio._id,
    vitalInfo: { ...hermioneBio.vitalInfo },
    prompts: [
      { ...hermioneBio.prompts[0] },
      { ...hermioneBio.prompts[1] },
      { ...hermioneBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Everything is fine, you seem like a total catch`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Wizard Chess... sounds like you're looking for me`,
        verdict: 'Very', 
      },
      {
        feedback: `Too true lol... I find it funny but someone who doesn't know you might not realize you're joking`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `Who says portkeys?`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Hermione is very pretty and well put together, but maybe a bit intense.`,
    good: `You're obviously super organized and well-oriented, and you manage to make yourself look pretty somehow too`,
    notGood: `The intensity. Try a few more pictures where you're smiling.`,
    verdict: `Overall the positives outweigh the negatives, but you're not yet showing your most attractive self. Adding a few more smiling photos could really take your profile to the next level`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...ronReviewerReviewHinge },
  reviewerProfile: { ...ronReviewerProfile },
  bioItems: { ...hermioneBio },
  mediaItems: [ ...hermioneMediaArray ],
}

export const dumbledoreProfileReviewBumble = {
  _id: 'dumbledoreProfileReviewBumbleId',
  userId: 'hermioneUserId',
  userEmail: 'hermione@email.com',
  datingProfileId: 'hermioneDatingProfileBumbleId',
  reviewerProfileId: 'dumbledoreReviewerProfileId',
  reviewerEmail: 'dumbledore@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: hermioneMediaArray[3]._id,
      mediaItemURL: hermioneMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[3].type,
      caption: hermioneMediaArray[3].captions[1],
      subcaption: hermioneMediaArray[3].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[1]._id,
      mediaItemURL: hermioneMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[1].type,
      caption: hermioneMediaArray[1].captions[1],
      subcaption: hermioneMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: hermioneMediaArray[5]._id,
      mediaItemURL: hermioneMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[5].type,
      caption: hermioneMediaArray[5].captions[0],
      subcaption: hermioneMediaArray[5].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[13]._id,
      mediaItemURL: hermioneMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[13].type,
      caption: hermioneMediaArray[13].captions[2],
      subcaption: hermioneMediaArray[13].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[9]._id,
      mediaItemURL: hermioneMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[9].type,
      caption: hermioneMediaArray[9].captions[2],
      subcaption: hermioneMediaArray[9].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[2]._id,
      mediaItemURL: hermioneMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[2].type,
      caption: hermioneMediaArray[2].captions[2],
      subcaption: hermioneMediaArray[2].subcaptions[1],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Wow against all odds you look like a wizard fatale here. Great start! (As shocking as that is for me to say)`,
      verdict: 'Very',
    },
    {
      feedback: `Looking as contemplative as ever by the fire. It pains me to say that yet again you look good, but maybe smile in one of these?`,
      verdict: 'Yes',
    },
    {
      feedback: `Wow! Who's that babe? Are you sure that's you?`,
      verdict: 'Very',
    },
    {
      feedback: `Action shot! I like it because I know the backstory, but I think someone who doesn't know you might find it a bit intense`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Supermodel alert! Again, it's good, but you look intense in too many photos. Do you ever smile?`,
      verdict: 'Somewhat',
    },
    {
      feedback: `This is funny! Love the caption, and you look good!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: hermioneBio._id,
    vitalInfo: { ...hermioneBio.vitalInfo },
    prompts: [
      { ...hermioneBio.prompts[0] },
      { ...hermioneBio.prompts[1] },
      { ...hermioneBio.prompts[2] }
    ],
    aboutMe: hermioneBio.aboutMe[0],
    hobbies: [hermioneBio.hobbies[0], hermioneBio.hobbies[1], hermioneBio.hobbies[2], hermioneBio.hobbies[3], hermioneBio.hobbies[4] ],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `You seem super intelligent and well oriented`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: `Love it! So spot on! You're a talented humorist`,
      verdict: 'Very', 
    },
    promptsFeedback: [
      {
        feedback: `Wizard Chess... sounds like you're looking for me`,
        verdict: 'Very', 
      },
      {
        feedback: `Too true lol... I find it funny but someone who doesn't know you might not realize you're joking`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `Who says portkeys?`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Hermione is very pretty and well put together, but maybe a bit intense.`,
    good: `You're obviously super organized and well-oriented, and you manage to make yourself look pretty somehow too`,
    notGood: `The intensity. Try a few more pictures where you're smiling.`,
    verdict: `Overall the positives outweigh the negatives, but you're not yet showing your most attractive self. Adding a few more smiling photos could really take your profile to the next level`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...dumbledoreReviewerReviewBumble },
  reviewerProfile: { ...dumbledoreReviewerProfile },
  bioItems: { ...hermioneBio },
  mediaItems: [ ...hermioneMediaArray ],
}

export const harryProfileReviewTinder = {
  _id: 'harryProfileReviewTinderId',
  userId: 'hermioneUserId',
  userEmail: 'hermione@email.com',
  datingProfileId: 'hermioneDatingProfileTinderId',
  reviewerProfileId: 'harryReviewerProfileId',
  reviewerEmail: 'harry@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: hermioneMediaArray[3]._id,
      mediaItemURL: hermioneMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[3].type,
      caption: hermioneMediaArray[3].captions[1],
      subcaption: hermioneMediaArray[3].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[1]._id,
      mediaItemURL: hermioneMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[1].type,
      caption: hermioneMediaArray[1].captions[1],
      subcaption: hermioneMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: hermioneMediaArray[5]._id,
      mediaItemURL: hermioneMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[5].type,
      caption: hermioneMediaArray[5].captions[0],
      subcaption: hermioneMediaArray[5].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[13]._id,
      mediaItemURL: hermioneMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[13].type,
      caption: hermioneMediaArray[13].captions[2],
      subcaption: hermioneMediaArray[13].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[9]._id,
      mediaItemURL: hermioneMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[9].type,
      caption: hermioneMediaArray[9].captions[2],
      subcaption: hermioneMediaArray[9].subcaptions[2],
    },
    {
      mediaItemId: hermioneMediaArray[2]._id,
      mediaItemURL: hermioneMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hermioneMediaArray[2].type,
      caption: hermioneMediaArray[2].captions[2],
      subcaption: hermioneMediaArray[2].subcaptions[1],
    }
  ],
  mediaFeedback: [
    {
      feedback: `Wow against all odds you look like a wizard fatale here. Great start! (As shocking as that is for me to say)`,
      verdict: 'Very',
    },
    {
      feedback: `Looking as contemplative as ever by the fire. It pains me to say that yet again you look good, but maybe smile in one of these?`,
      verdict: 'Yes',
    },
    {
      feedback: `Wow! Who's that babe? Are you sure that's you?`,
      verdict: 'Very',
    },
    {
      feedback: `Action shot! I like it because I know the backstory, but I think someone who doesn't know you might find it a bit intense`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Supermodel alert! Again, it's good, but you look intense in too many photos. Do you ever smile?`,
      verdict: 'Somewhat',
    },
    {
      feedback: `This is funny! Love the caption, and you look good!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: hermioneBio._id,
    vitalInfo: { ...hermioneBio.vitalInfo },
    prompts: [
      { ...hermioneBio.prompts[0] },
      { ...hermioneBio.prompts[1] },
      { ...hermioneBio.prompts[2] }
    ],
    aboutMe: hermioneBio.aboutMe[0],
    hobbies: [hermioneBio.hobbies[0], hermioneBio.hobbies[1], hermioneBio.hobbies[2], hermioneBio.hobbies[3], hermioneBio.hobbies[4] ],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `You seem super intelligent and well oriented`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: `Love it! So spot on! You're a talented humorist`,
      verdict: 'Very', 
    },
    promptsFeedback: [
      {
        feedback: `Wizard Chess... sounds like you're looking for me`,
        verdict: 'Very', 
      },
      {
        feedback: `Too true lol... I find it funny but someone who doesn't know you might not realize you're joking`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `Who says portkeys?`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Hermione is very pretty and well put together, but maybe a bit intense.`,
    good: `You're obviously super organized and well-oriented, and you manage to make yourself look pretty somehow too`,
    notGood: `The intensity. Try a few more pictures where you're smiling.`,
    verdict: `Overall the positives outweigh the negatives, but you're not yet showing your most attractive self. Adding a few more smiling photos could really take your profile to the next level`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...harryReviewerReviewTinder },
  reviewerProfile: { ...harryReviewerProfile },
  bioItems: { ...hermioneBio },
  mediaItems: [ ...hermioneMediaArray ],
}